import React from 'react';

import { useExternalJobBoardsState, useExternalJobBoardsActions } from './ExternalJobBoardsContext';

import { verifyExternalJobBoard, rejectExternalJobBoard, archiveExternalJobBoard, cacheWebpage, syncJobs, refreshPreviewedLinks } from './restApi';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Dropdown from '../../Shared/UI/Dropdown/components/Dropdown';
import Button from '../../Shared/UI/Button/components/Button';

const ExternalJobBoardsTable = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { onResponse, onError, openUpdateExternalJobBoardModal, openPreviewLinkDataModal, openDeleteExternalJobBoardModal } = useExternalJobBoardsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Biopharma Group</Th>
          <Th>Link</Th>
          <Th>Last Synced At</Th>
          <Th>State</Th>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        {externalJobBoardsState?.externalJobBoards?.map(externalJobBoard => (
          <Tr key={externalJobBoard.id}>
            <Td>
              <a href={`/biopharma_groups/${externalJobBoard.biopharmaGroup.id}`} target="_blank" rel="noopener noreferrer">
                {externalJobBoard.biopharmaGroup.name}
              </a>
            </Td>
            <Td>
              <a href={externalJobBoard.url} target="_blank" rel="noopener noreferrer">link</a>
            </Td>
            <Td>
              {externalJobBoard.lastSyncedAt
                ? new Date(externalJobBoard.lastSyncedAt).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZoneName: 'short'
                  })
                : 'Never'
              }
            </Td>
            <Td>{externalJobBoard.aasmState}</Td>
            <Td>
              <Dropdown
                trigger={<Button variant="secondary" size="sm">Actions</Button>}
                align="right"
              >
                <Dropdown.Item onClick={() => openUpdateExternalJobBoardModal(externalJobBoard)}>
                  Update
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    cacheWebpage({
                      onResponse,
                      onError,
                      body: {
                        authenticityToken,
                        externalJobBoardId: externalJobBoard.id,
                      },
                    });
                  }}
                >
                  Cache Webpage
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    syncJobs({
                      onResponse,
                      onError,
                      body: {
                        authenticityToken,
                        externalJobBoardId: externalJobBoard.id,
                      },
                    });
                  }}
                >
                  Sync Jobs
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => openPreviewLinkDataModal(externalJobBoard)}
                >
                  Preview Links
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    refreshPreviewedLinks({
                      onResponse,
                      onError,
                      body: {
                        authenticityToken,
                        externalJobBoardId: externalJobBoard.id,
                      },
                    });
                  }}
                >
                  Refresh Previewed Links
                </Dropdown.Item>
                <Dropdown.Divider />
                {externalJobBoard.aasmState !== 'verified' && (
                  <Dropdown.Item
                    onClick={() => {
                      verifyExternalJobBoard({
                        onResponse,
                        onError,
                        body: {
                          authenticityToken,
                          externalJobBoardId: externalJobBoard.id,
                        },
                      });
                    }}
                  >
                    Verify
                  </Dropdown.Item>
                )}
                {externalJobBoard.aasmState !== 'rejected' && (
                  <Dropdown.Item
                    onClick={() => {
                      rejectExternalJobBoard({
                        onResponse,
                        onError,
                        body: {
                          authenticityToken,
                          externalJobBoardId: externalJobBoard.id,
                        },
                      });
                    }}
                  >
                    Reject
                  </Dropdown.Item>
                )}
                {externalJobBoard.aasmState !== 'archived' && (
                  <Dropdown.Item
                    onClick={() => {
                      archiveExternalJobBoard({
                        onResponse,
                        onError,
                        body: {
                          authenticityToken,
                          externalJobBoardId: externalJobBoard.id,
                        },
                      });
                    }}
                  >
                    Archive
                  </Dropdown.Item>
                )}
                <Dropdown.Divider />
                <Dropdown.Item
                  onClick={() => openDeleteExternalJobBoardModal(externalJobBoard)}
                  destructive
                >
                  Delete
                </Dropdown.Item>
              </Dropdown>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default ExternalJobBoardsTable;
